import { c as _c } from "react/compiler-runtime";
import { Divider as AntdDivider } from 'antd';
import { DividerProps as AntdDividerProps } from 'antd/es/divider';
import cx from 'classnames';
import './styles.scss';
const PrefixCls = 'app-divider';
export enum MarginSize {
  // !Warning: Please sync those values with the scss
  None = 'none',
  Small = 'small',
  Small2 = 'small-2',
  Medium = 'medium',
  Medium2 = 'medium-2',
  Default = 'default',
  Large2 = 'large-2',
}
interface DividerProps extends AntdDividerProps {
  verticalMargin?: `${MarginSize}`;
}

/**
 * This class is a wrap around [antd Divider](https://ant.design/components/divider/) component extending some of
 * the properties to follow our styling guidelines.
 *
 * Please refer to antd documentation for more details.
 *
 */
export function Divider(t0) {
  const $ = _c(10);
  let className;
  let props;
  let verticalMargin;
  if ($[0] !== t0) {
    ({
      className,
      verticalMargin,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = verticalMargin;
  } else {
    className = $[1];
    props = $[2];
    verticalMargin = $[3];
  }
  const t1 = verticalMargin && `${PrefixCls}-margin--${verticalMargin}`;
  let t2;
  if ($[4] !== className || $[5] !== t1) {
    t2 = cx(PrefixCls, t1, className);
    $[4] = className;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props || $[8] !== t2) {
    t3 = <AntdDivider {...props} className={t2} />;
    $[7] = props;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
Divider.displayName = AntdDivider.displayName;